export default __webpack_public_path__ + "static/media/roboto-700.75371f53.ttf";